var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9994 10.9468C10.8275 10.9468 11.4988 10.2829 11.4988 9.46378C11.4988 8.6447 10.8275 7.98071 9.9994 7.98071C9.17131 7.98071 8.5 8.6447 8.5 9.46378C8.5 10.2829 9.17131 10.9468 9.9994 10.9468Z",
    fill: "#131F43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8661 8.96941C19.2263 7.87194 15.7077 2.36482 9.73011 2.54279C4.2023 2.68121 1.00358 7.48634 0.133921 8.96941C0.046188 9.11971 0 9.29021 0 9.46376C0 9.63732 0.046188 9.80781 0.133921 9.95812C0.763671 11.0358 4.13233 16.3847 10.02 16.3847H10.2699C15.7977 16.2463 19.0064 11.4412 19.8661 9.95812C19.9538 9.80781 20 9.63732 20 9.46376C20 9.29021 19.9538 9.11971 19.8661 8.96941ZM10 12.9242C9.30804 12.9242 8.63162 12.7213 8.05628 12.341C7.48093 11.9608 7.03251 11.4204 6.76771 10.788C6.5029 10.1557 6.43362 9.45992 6.56861 8.78865C6.70361 8.11738 7.03682 7.50079 7.52611 7.01683C8.0154 6.53287 8.63879 6.20329 9.31746 6.06977C9.99612 5.93624 10.6996 6.00477 11.3389 6.26669C11.9781 6.52861 12.5246 6.97214 12.909 7.54122C13.2934 8.11029 13.4986 8.77934 13.4986 9.46376C13.4986 10.3815 13.13 11.2617 12.4739 11.9107C11.8178 12.5597 10.9279 12.9242 10 12.9242Z",
    fill: "#131F43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53809 1L18.4612 18.6923",
    stroke: "#131F43",
    strokeWidth: 1.53846
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close_eye.d2a2bc82f526c2e390beeeeb40f11d1c.svg";
export { ForwardRef as ReactComponent };